import {
  ChangeDetectorRef,
  Component,
  NgZone,
  OnChanges,
  OnInit,
} from "@angular/core";
import * as CryptoJS from "crypto-js";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
  ValidationErrors,
  AbstractControl,
  FormArray,
} from "@angular/forms";
import { OnboardingService } from "../../shared/service/onboarding.service";
import { OnboardingHRDetail } from "../../shared/models/OnboardingHRDetail";
import { Router, ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { DatePipe, formatDate } from "@angular/common";
import { AppConfig } from "../../app.config";
import { UserService } from "../../shared/service/user.service";
import { DepartmentsService } from "../../shared/service/departments.service";
import { CadreService } from "../../shared/service/cadre.service";
import { isNullOrUndefined } from "util";
import { OnboardOTP } from "../../shared/models/OnboardOTP";
import {
  DesignationDialogComponent,
  DesignationDialog,
} from "../../shared/components/designation-dialog/designation-dialog.component";
import { MatDialog, MatSelect } from "@angular/material";
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from "@angular/material-moment-adapter";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from "@angular/material/core";
import {
  DepartmentDialogComponent,
  DepartmentDialog,
} from "../../shared/components/department-dialog/department-dialog.component";
import {
  CadreDialog,
  CadreDialogComponent,
} from "../../shared/components/cadre-dialog/cadre-dialog.component";

// Depending on whether rollup is used, moment needs to be imported differently.
// Since Moment.js doesn't have a default export, we normally need to import using the `* as`
// syntax. However, rollup creates a synthetic default module and we thus need to import it using
// the `default as` syntax.
import * as _moment from "moment";
import {
  ProfilesourceDialog,
  ProfilesourceDialogComponent,
} from "../../shared/components/profilesource-dialog/profilesource-dialog.component";
import { EmployeeService } from "../../shared/service/employee.service";
import { BasicEmployeeDetails } from "../../shared/models/basicemployeedetails.model";
import {
  ConfirmDialogComponent,
  ConfirmDialogModel,
} from "../../shared/components/confirm-dialog/confirm-dialog.component";
import {
  BonusDialog,
  CompensationDialogComponent,
} from "../../shared/components/compensation-dialog/compensation-dialog.component";
import { BehaviorSubject } from "rxjs";
import { File_Types, Resume_File_Types } from "../../shared/UploadFileTypes";
import { FileUploadService } from "../../shared/service/fileUpload.service";
import { ScrollingModule } from "@angular/cdk/scrolling";
// tslint:disable-next-line:no-duplicate-imports
//import { default as _rollupMoment } from 'moment';

const moment = _moment;

// See the Moment.js docs for the meaning of these formats:
// https://momentjs.com/docs/#/displaying/format/
export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MMM-YYYY",
  },
  display: {
    dateInput: "DD-MMM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};
@Component({
  selector: "app-add-onboarding-details",
  templateUrl: "./add-onboarding-details.component.html",
  styleUrls: ["./add-onboarding-details.component.css"],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class AddOnboardingDetailsComponent implements OnInit, OnChanges {
  error: string;
  date: Date;
  HREmp: OnboardingHRDetail;
  EmpGroupIDDetails: any;
  IsExpand = true;
  onboardingform: FormGroup;
  hrCtcDetailsForm: FormGroup;
  submitted = false;
  exception = false;
  minDOJ = new Date();
  designationsList: any[];
  locationsList: any;
  departmentsList: any;
  cadresList: any;
  datePipe: DatePipe;
  empCode: any;
  EmpId: any;
  Required: boolean = false;
  RequiredDept: boolean = false;
  RequiredCadre: boolean = false;
  filteredList: any;
  designationId: any;
  departmentId: any;
  cadreId: any;
  employeelist: any[] = [];
  todayDate: Date;
  maxDate: Date;
  currentYear: any;
  currentMonth: any;
  currentDate: any;
  emailemp: any;
  mobileemp: any[] = [];
  sample: string;
  jobsources: any;
  jobPlatform: any;
  selectedProfileSource: number;
  filteredEmpList: any;
  empList: any[] = [];
  RecruiterId: any;
  RecruiterDesignation: any;
  isLoader: boolean = true;
  oldJobSource: string = null;
  showOtherControl = false;
  disablesubmit = false;
  BasicEmployeeList: BasicEmployeeDetails[];
  result: any;
  bonusDetails: FormArray = this.formBuilder.array([]);
  bonusOptions: any[] = [];
  selectedBonusOptions: string[] = [];
  gettingBasicDet: BasicEmployeeDetails;
  private employeelistSubject = new BehaviorSubject<BasicEmployeeDetails[]>([]);
  MAX_SIZE: number = 1048576;
  eeTypeList: any;
  teamList: any;
  hasAddPermission = false;
  //  [
  //  { value: 'IPA', label: 'IPA' },
  //  { value: 'CPA', label: 'CPA' },
  //  { value: 'Performance Bonus', label: 'Performance Bonus' },
  //  { value: 'Retention Bonus', label: 'Retention Bonus' },
  //  { value: 'Stretch Bonus', label: 'Stretch Bonus' },
  //  { value: 'Variable Pay', label: 'Variable Pay' },
  //  { value: 'Long Term Bonus', label: 'Long Term Bonus' }
  //];
  emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  OtpText: boolean;
  slug: string;
  _onboardOTP: OnboardOTP;
  isAllowAccess: boolean = false;
  CTCComponentsList = [];
  mainCmp = [
    "EffectiveDate",
    "FixedCTC",
    "IPA",
    "CPA",
    "Performance Bonus",
    "Retention Bonus",
    "Variable Pay",
  ];
  newlyAddedCtcCmp = [];
  newlyAddedBonusCmp = [];
  allCmpCount = 0;
  bonusCmp = ["Stretch Bonus", "Long Term Bonus"];
  staticCmp = ["JoiningBonus", "RelocationEligibility"];
  offerCmp = ["OfferLetterDocumentPath"];
  arrFilesList = [];
  iconVisible: boolean = false;
  privateKeyBase64: string = "b14ca5898a4e4133bbce2ea2315a1916";
  encryptedData: any = ""; // Base64 encrypted data (received from the backend)
  decryptedData: any = ""; // Decrypted data
  LoginEmpCode: any;
  IsHidden: boolean = false;
  MobileNo: any;
  isUpdated = null;

  constructor(
    private onboardsvc: OnboardingService,
    private formBuilder: FormBuilder,
    private userService: UserService,
    private config: AppConfig,
    private hrSvc: OnboardingService,
    private router: Router,
    private toastr: ToastrService,
    private cadreSvc: CadreService,
    private deptSvc: DepartmentsService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    public emp_Svc: EmployeeService,
    private zone: NgZone,
    private file_Svc: FileUploadService,
    private cdr: ChangeDetectorRef,
    private _onboardingService: OnboardingService
  ) {
    this.HREmp = new OnboardingHRDetail();
    this.HREmp.JoiningBonus = "0";
    this.HREmp.Employee_Status = "Active";
    this.todayDate = new Date();
    this.currentYear = new Date().getFullYear();
    this.currentMonth = new Date().getMonth();
    this.currentDate = new Date().getDate();
    this.maxDate = new Date(
      this.currentYear + 1,
      this.currentMonth,
      this.currentDate
    );
    this.minDOJ = new Date(
      this.currentYear,
      this.currentMonth,
      this.currentDate - 7
    );
    this.getDesignations();
    this.getAllEmployees();
  }

  checkPermission() {
    var permission = this.userService.userInfo.permissions.find(
      (i) => i.Menu === "Onboarding"
    );
    this.hasAddPermission =
      permission != null
        ? permission.AddingPermission || permission.HasFullAccess
        : false;
  }

  ngOnChanges() { }

  async ngOnInit() {
    this._onboardOTP = new OnboardOTP();
    this.isLoader = true;
    this.checkPermission();
    this.getBonusList();
    this.initializeForm();
    await this.getEmployeeList();
    this.route.params.subscribe((params) => {
      this.EmpId = params["id"];
    });
    if (!isNullOrUndefined(this.EmpId)) {
      this.getJobSources();
      this.getDesignations();
      this.getCadreData();
      this.getDeptData();
      this.getEmployeeById();
      setTimeout(() => {
        this.getData();
      }, 2000);
    } else {
      this.getDesignations();
      this.getJobSources();
      this.createCompenstationData();
      this.getBasicEmployeeByCodeforNumber();
    }
    //this.bonusDetails = this.formBuilder.array([]);
    this.empCode = this.userService.getEmpCode();
    this.LoginEmpCode = this.userService.getEmpCode();
    this.getLocations();
    this.getDepartments();
    this.getCadres();
    this.getTeams();
    this.getEeTypeList();
    this.getAllEmplist();

    //this.onboardingform.get('RecruiterId').valueChanges.subscribe(value => {
    //  this.doEmpFilter(value); // Filter list based on input value
    //});

    this.onboardingform.get("ProfileSource").valueChanges.subscribe((val) => {
      if (val === "Vendor" || val === "Referral" || val === "RPO") {
        this.onboardingform.controls["ProfileSourceCategoryTwo"].setValidators([
          Validators.required,
          Validators.maxLength(15),
          Validators.pattern("^\\d{1,12}(\\.\\d{0,2})?$"),
        ]);
      } else {
        this.onboardingform.controls[
          "ProfileSourceCategoryTwo"
        ].clearValidators();
      }
    });

    setTimeout(() => {
      this.isLoader = false;
    }, 1500);
  }

  initializeForm() {
    this.bonusDetails = this.formBuilder.array([]);
    const nonWhitespaceRegExp: RegExp = new RegExp("\\S");
    this.onboardingform = this.formBuilder.group({
      firstName: [
        "",
        [
          Validators.required,
          Validators.pattern("^[a-zA-Z -']+"),
          Validators.pattern(nonWhitespaceRegExp),
        ],
      ],
      lastName: [
        "",
        [
          Validators.pattern("^[a-zA-Z -']+"),
          Validators.pattern(nonWhitespaceRegExp),
        ],
      ],
      Type: ["", [Validators.required]],
      GroupId: [""],
      //emailId: ["", [Validators.required, Validators.email]],
      emailId: [
        "",
        [
          Validators.required,
          Validators.email,
          Validators.pattern(this.emailRegex),
        ],
      ],
      designation: ["", [Validators.required, this.requireMatch.bind(this)]],
      doj: [moment(), [Validators.required]],
      ProfileSource: [
        "",
        [Validators.required, this.requireMatchProfileSource.bind(this)],
      ],
      ProfileSourceCategoryOne: ["", [Validators.required]],
      ProfileSourceCategoryTwo: [
        "",
        //[
        //  Validators.required,
        //  Validators.pattern("^\\d{1,12}(\\.\\d{0,2})?$"),
        //  Validators.maxLength(15),
        //],
      ],
      HiringType: ["", [Validators.required]],
      Department: ["", [Validators.required, this.requireMatchDept.bind(this)]],
      Cadre: ["", [Validators.required, this.requireMatchCadre.bind(this)]],
      mobileNo: [
        "",
        [
          Validators.required,
          Validators.pattern("[0-9]*"),
          Validators.minLength(10),
        ],
      ],
      jobLocation: ["", [Validators.required]],
      RecruiterId: [
        "",
        [Validators.required, this.requireMatchRecruiterId.bind(this)],
      ],
      RecruiterDesignationId: [""],
      JoiningBonus: [
        // "",
        // [
        //   Validators.required,
        //   Validators.pattern("^\\d{1,12}(\\.\\d{0,2})?$"),
        //   Validators.maxLength(15),
        // ],
      ],
      // fixedCTC: [],
      // relocationEligibility: [],
      // OfferLetterFile: [],
      bonusDetails: this.bonusDetails,
      EmpStatus: [""],
      TeamId: ["", [Validators.required]],
      EeTypeId: ["", [Validators.required]],
    });

    this.hrCtcDetailsForm = this.formBuilder.group({
      EffectiveDate: ["", [Validators.required]],
      FixedCTC: [
        "",
        [
          Validators.pattern("^\\d{1,12}(\\.\\d{0,2})?$"),
          Validators.maxLength(15),
        ],
      ],
      IPA: [
        "",
        [
          Validators.pattern("^\\d{1,12}(\\.\\d{0,2})?$"),
          Validators.maxLength(15),
        ],
      ],
      CTC: [
        "",
        [
          Validators.pattern("^\\d{1,12}(\\.\\d{0,2})?$"),
          Validators.maxLength(15),
        ],
      ],
      CPA: [
        "",
        [
          Validators.pattern("^\\d{1,12}(\\.\\d{0,2})?$"),
          Validators.maxLength(15),
        ],
      ],
      "Performance Bonus": [
        "",
        [
          Validators.pattern("^\\d{1,12}(\\.\\d{0,2})?$"),
          Validators.maxLength(15),
        ],
      ],
      "Retention Bonus": [
        "",
        [
          Validators.pattern("^\\d{1,12}(\\.\\d{0,2})?$"),
          Validators.maxLength(15),
        ],
      ],
      "Stretch Bonus": [
        "",
        [
          Validators.pattern("^\\d{1,12}(\\.\\d{0,2})?$"),
          Validators.maxLength(15),
        ],
      ],
      "Variable Pay": [
        "",
        [
          Validators.pattern("^\\d{1,12}(\\.\\d{0,2})?$"),
          Validators.maxLength(15),
        ],
      ],
      "Long Term Bonus": [
        "",
        [
          Validators.pattern("^\\d{1,12}(\\.\\d{0,2})?$"),
          Validators.maxLength(15),
        ],
      ],
      RelocationEligibility: "",
      OfferLetterDocumentPath: "",
    });
  }

  handleInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;

    // Perform conditional logic based on ProfileSource
    if (
      this.HREmp.ProfileSource === "Vendor" ||
      this.HREmp.ProfileSource === "Referral" ||
      this.HREmp.ProfileSource === "RPO"
    ) {
      input.value = value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
    }
  }

  addItem(item = null) {
    if (item != null) {
      var row = this.formBuilder.group({
        Id: item.Id,
        EmpId: item.EmpCode,
        BonusId: item.BonusId,
        Name: item.Name,
        Amount: item.Amount,
      });
    } else {
      var row = this.formBuilder.group({
        Id: [""],
        EmpId: [""],
        BonusId: [""],
        Name: [""],
        Amount: [""],
      });
    }
    this.bonusDetails.push(row);
  }

  deleteItem(index) {
    const message = `Please confirm if you want to delete this record?`;
    var deleteType = "Record";
    const dialogData = new ConfirmDialogModel(" ", message, deleteType);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.bonusDetails.value.splice(index, 1);
          var array = this.bonusDetails.value;
          this.bonusDetails.clear();
          for (var i = 0; i < array.length; i++) {
            this.onSelectionChange(i, array[i].Name);
            this.addItem(array[i]);
          }
          this.cdr.detectChanges();
        }
      },
      (error) => {
        this.result = error;
      }
    );
  }

  get f() {
    return this.onboardingform.controls;
  }
  getDesignations() {
    this.hrSvc.getDesignations().subscribe((data: any) => {
      this.Required = true;
      this.designationsList = data;
      this.filteredList = this.designationsList;
    });
  }

  getJobSources() {
    this.hrSvc.getJobSources().subscribe((data: any) => {
      this.jobsources = data;
    });
  }

  getJobPlatform(Id) {
    this.hrSvc.getJobPlatforms(Id).subscribe((data: any) => {
      this.jobPlatform = data;
      if (this.jobPlatform != null && this.jobPlatform.length > 0) {
        this.jobPlatform = this.jobPlatform.filter(
          (element) => element.Name != null && element.Name != ""
        );
      }
    });
  }

  //getJobPlatformDetails() {
  //  const selectedId = this.jobsources.find(
  //    ({ Name }) => Name === this.HREmp.ProfileSource
  //  );
  //  if (selectedId && selectedId.Id) {
  //    this.hrSvc.getJobPlatforms(selectedId.Id).subscribe((data: any) => {
  //      this.jobPlatform = data;
  //      this.jobPlatform != null && this.jobPlatform.length > 0;
  //      {
  //        this.jobPlatform = this.jobPlatform.filter(
  //          (element) => element.Name != null && element.Name != ""
  //        );
  //      }
  //    });
  //  }
  //}

  getJobPlatformDetails() {
    const selectedId = this.jobsources.find(
      ({ Name }) => Name === this.HREmp.ProfileSource
    );
    if (selectedId && selectedId.Id) {
      this.hrSvc.getJobPlatforms(selectedId.Id).subscribe((data: any) => {
        this.jobPlatform = data;
        this.jobPlatform != null && this.jobPlatform.length > 0;
        this.jobPlatform = this.jobPlatform.filter(
          (element) => element.Name != null && element.Name != ""
        );
        const selectedOption = this.jobPlatform.find(
          (platform) => platform.Name === this.HREmp.ProfileSourceCategoryOne
        );
        if (selectedOption) {
          this.HREmp.ProfileSourceCategoryOne = selectedOption.Id;
        }
      });
    }
  }

  ctcCalculationFun(event, index) {
    let filteredList = this.bonusOptions
      .filter(({ IsCTC, Name }) => IsCTC === true)
      .map(({ Name }) => Name);

    let finalData = this.HREmp.employeeBonusDetailsList;
    let count = 0;
    filteredList = ["FixedCTC", ...filteredList];
    if (filteredList && filteredList.length > 0) {
      filteredList = [...new Set(filteredList)]
      filteredList.map((item) => {
        count = Number(count) + Number(finalData[index][item] || 0);
      });
    }
    finalData[index].CTC = count;
    this.HREmp.employeeBonusDetailsList = finalData;
  }

  showNewHikeConfirmationDialog() {
    const message = `Please confirm if you want to trigger new hike?`;
    const dialogData = new ConfirmDialogModel(" ", message, "Submit");
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.addNewHikeRow();
        }
      },
      (error) => {
        this.result = error;
      }
    );
  }

  addNewCtcCmp() {
    if (this.bonusOptions && this.bonusOptions.length > 0) {
      const allKeys = [];
      if (this.bonusOptions.length > 0) {
        this.bonusOptions.map((item) => {
          allKeys.push(item.Name);
        });
      }
      const orgArray = [...new Set(allKeys)];
      const stringsToExclude = [
        "EmpCode",
        ...this.mainCmp,
        ...this.bonusCmp,
        ...this.staticCmp,
        ...this.offerCmp,
      ];
      const newArrayCtcCmp = this.bonusOptions
        .filter(({ IsCTC, Name }) => IsCTC && !stringsToExclude.includes(Name))
        .map(({ Name }) => Name);
      const newArrayBonusCmp = this.bonusOptions
        .filter(({ IsCTC, Name }) => !IsCTC && !stringsToExclude.includes(Name))
        .map(({ Name }) => Name);
      this.newlyAddedCtcCmp = newArrayCtcCmp;
      this.newlyAddedBonusCmp = newArrayBonusCmp;
      this.CTCComponentsList = [
        ...this.mainCmp,
        ...newArrayCtcCmp,
        "ADD",
        "CTC",
        ...this.bonusCmp,
        ...this.newlyAddedBonusCmp,
        "ADDBonus",
        ...this.staticCmp,
        ...this.offerCmp,
      ];
      this.allCmpCount = [...this.mainCmp, ...newArrayCtcCmp].length;
    }
  }

  addNewHikeRow() {
    if (this.HREmp.employeeBonusDetailsList.length > 0) {
      const addNew = [
        {
          isNew: true,
          EffectiveDate: new Date(),
          FixedCTC: "",
          IPA: "",
          CPA: "",
          "Performance Bonus": "",
          "Retention Bonus": "",
          "Variable Pay": "",
          ADD: "",
          CTC: "",
          "Stretch Bonus": "",
          JoiningBonus: "",
          "Long Term Bonus": "",
          RelocationEligibility: "",
        },
      ];
      this.HREmp.employeeBonusDetailsList = [
        ...addNew,
        ...this.HREmp.employeeBonusDetailsList,
      ];
    }
  }

  deleteHikeRow(j) {
    const message = `Please confirm if you want to delete this section?`;
    const dialogData = new ConfirmDialogModel(" ", message, "Submit");
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          const mainArr = this.HREmp.employeeBonusDetailsList;
          const finalData = mainArr.filter((e, i) => i !== j);
          this.HREmp.employeeBonusDetailsList = [...finalData];
          this.toastr.error("Deleted selected data successfully!");
        }
      },
      (error) => {
        this.result = error;
      }
    );
  }

  decryptAES(encryptedData, privateKeyBase64: string) {
    try {
      let cipherPhrase = privateKeyBase64;

      var key = CryptoJS.enc.Utf8.parse(cipherPhrase);
      var iv = CryptoJS.enc.Utf8.parse("");

      if (encryptedData) {
        var decrypted = CryptoJS.AES.decrypt(encryptedData.trim(), key, {
          keySize: 128 / 8,
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        });

        if (decrypted) {
          return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
        } else {
          return decrypted.toString(CryptoJS.enc.Utf8);
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  createCompenstationData() {
    this.emp_Svc.getEmpBonus().subscribe(
      (data: any) => {
        this.bonusOptions = data || [];
        this.HREmp = new OnboardingHRDetail();
        this.HREmp.JoiningBonus = "0";

        const allKeys = [];
        if (this.bonusOptions && this.bonusOptions.length > 0) {
          this.bonusOptions.map((item) => {
            allKeys.push(item.Name);
          });
        }
        const orgArray = [...new Set(allKeys)];
        const stringsToExclude = [
          "EmpCode",
          ...this.mainCmp,
          ...this.bonusCmp,
          ...this.staticCmp,
          ...this.offerCmp,
        ];
        const newArrayCtcCmp = this.bonusOptions
          .filter(
            ({ IsCTC, Name }) => IsCTC && !stringsToExclude.includes(Name)
          )
          .map(({ Name }) => Name);
        const newArrayBonusCmp = this.bonusOptions
          .filter(
            ({ IsCTC, Name }) => !IsCTC && !stringsToExclude.includes(Name)
          )
          .map(({ Name }) => Name);
        this.newlyAddedCtcCmp = newArrayCtcCmp;
        this.newlyAddedBonusCmp = newArrayBonusCmp;
        this.CTCComponentsList = [
          ...this.mainCmp,
          ...newArrayCtcCmp,
          "ADD",
          "CTC",
          ...this.bonusCmp,
          ...this.newlyAddedBonusCmp,
          "ADDBonus",
          ...this.staticCmp,
          ...this.offerCmp,
        ];

        this.allCmpCount = [...this.mainCmp, ...newArrayCtcCmp].length;

        this.HREmp.employeeBonusDetailsList = [
          {
            EffectiveDate: new Date(),
            FixedCTC: "",
            IPA: "",
            CPA: "",
            "Performance Bonus": "",
            "Retention Bonus": "",
            "Variable Pay": "",
            ADD: "",
            CTC: "",
            "Stretch Bonus": "",
            JoiningBonus: "",
            "Long Term Bonus": "",
            RelocationEligibility: "",
          },
        ];
      },
      (error) => {
        this.error = error;
      }
    );
  }

  getData() {
    this.getBonusList();
    const bonusListControl = this.onboardingform.get(
      "bonusDetails"
    ) as FormArray;
    bonusListControl.clear();
    this.hrSvc.getEmployeebyId(this.EmpId).subscribe((data: any) => {
      if (data == null) {
        this.HREmp = new OnboardingHRDetail();
        this.HREmp.JoiningBonus = "0";
        this.HREmp.employeeBonusDetailsList = [];
        this.isLoader = false;
      }

      if (data != null) {
        this.HREmp = data;
        if (
          this.HREmp &&
          this.HREmp.employeeBonusDetailsList != null &&
          this.HREmp.employeeBonusDetailsList.length > 0
        ) {
          this.encryptedData = this.HREmp.employeeBonusDetailsList;
          const decryptedData = this.encryptedData.map((obj) => {
            Object.entries(obj).forEach(([key, value]) => {
              obj[key] =
                key === "RelocationEligibility"
                  ? value
                  : key === "EffectiveDate"
                    ? value
                    : key === "EmpCode"
                      ? value
                      : key === "EmpId"
                        ? value
                        : key === "OfferLetterDocumentName"
                          ? value
                          : key === "OfferLetterDocumentPath"
                            ? value
                            : key === "JoiningBonus"
                              ? value
                              : this.decryptAES(value, this.privateKeyBase64);
            });
            return obj;
          });

          this.HREmp.employeeBonusDetailsList = decryptedData;
        }

        this.HREmp.DOJ = new Date(this.HREmp.DOJ);

        this.HREmp.Employee_Status =
          this.HREmp.Employee_Status == null
            ? "Active"
            : this.HREmp.Employee_Status;

        this.HREmp.mobileNumber = this.HREmp.mobileNumber.trim();
        this.designationsList.map((item) => {
          if (item.ID == this.HREmp.DesignationId) {
            this.designationId = item.DesignationName;
          }
        });
        //console.log(data)

        const recruiter = this.empList != null ? this.empList.find(item => item.EmpCode === this.HREmp.RecruiterId) : null;

        if (recruiter) {
          this.RecruiterId = recruiter.recDisplayName;
          this.RecruiterDesignation = recruiter.DesignationName;
        }
        if (data) {
          const allKeys = [];
          if (this.bonusOptions && this.bonusOptions.length > 0) {
            this.bonusOptions.map((item) => {
              allKeys.push(item.Name);
            });
          }
          const orgArray = [...new Set(allKeys)];
          const stringsToExclude = [
            "EmpCode",
            ...this.mainCmp,
            ...this.bonusCmp,
            ...this.staticCmp,
            ...this.offerCmp,
          ];
          const newArrayCtcCmp = this.bonusOptions
            .filter(
              ({ IsCTC, Name }) => IsCTC && !stringsToExclude.includes(Name)
            )
            .map(({ Name }) => Name);
          const newArrayBonusCmp = this.bonusOptions
            .filter(
              ({ IsCTC, Name }) => !IsCTC && !stringsToExclude.includes(Name)
            )
            .map(({ Name }) => Name);
          this.newlyAddedCtcCmp = newArrayCtcCmp;
          this.newlyAddedBonusCmp = newArrayBonusCmp;
          this.CTCComponentsList = [
            ...this.mainCmp,
            ...newArrayCtcCmp,
            "ADD",
            "CTC",
            ...this.bonusCmp,
            ...this.newlyAddedBonusCmp,
            "ADDBonus",
            ...this.staticCmp,
            ...this.offerCmp,
          ];
          this.allCmpCount = [...this.mainCmp, ...newArrayCtcCmp].length;
        }

        if (
          this.HREmp &&
          this.HREmp.employeeBonusDetailsList &&
          this.HREmp.employeeBonusDetailsList.length === 0
        ) {
          this.HREmp.employeeBonusDetailsList = [
            {
              EffectiveDate: new Date(),
              FixedCTC: "",
              IPA: "",
              CPA: "",
              "Performance Bonus": "",
              "Retention Bonus": "",
              "Variable Pay": "",
              ADD: "",
              CTC: "",
              "Stretch Bonus": "",
              JoiningBonus: "",
              "Long Term Bonus": "",
              RelocationEligibility: "",
            },
          ];
        }
        if (
          this.HREmp &&
          this.HREmp.employeeBonusDetailsList &&
          this.HREmp.employeeBonusDetailsList.length > 0
        ) {
          this.HREmp.employeeBonusDetailsList = [
            ...this.HREmp.employeeBonusDetailsList.reverse(),
          ];
        }

        // if (
        //   this.HREmp &&
        //   this.HREmp.employeeBonusDetails &&
        //   this.HREmp.employeeBonusDetails != null &&
        //   this.HREmp.employeeBonusDetails.length > 0
        // ) {
        //   this.zone.runOutsideAngular(() => {
        //     this.HREmp.employeeBonusDetails.forEach((item, index) => {
        //       this.onSelectionChange(index, item.Name);
        //       this.addItem(item);
        //     });
        //   });
        // }
        this.onboardingform
          .get("RecruiterDesignationId")
          .setValue(this.RecruiterDesignation);
        this.getJobPlatformDetails();
        const selectedRecObj = this.filteredEmpList.find(
          ({ EmpCode }) => EmpCode === this.HREmp.RecruiterId
        );

        var others = this.onboardingform.get("ProfileSourceCategoryTwo");
        if (
          this.HREmp.ProfileSource != null &&
          this.HREmp.ProfileSource != "" &&
          this.HREmp.ProfileSource != "Social Network" &&
          this.HREmp.ProfileSource != "Career Portal" &&
          this.HREmp.ProfileSource != "Job Board" &&
          this.HREmp.ProfileSource != "Direct re-hire"
        ) {
          this.showOtherControl = true;
        } else if (
          this.HREmp.ProfileSource != null &&
          this.HREmp.ProfileSource != ""
        ) {
          this.showOtherControl = false;
        }
        this.HREmp.JoiningBonus =
          this.HREmp.JoiningBonus == null ? "0" : this.HREmp.JoiningBonus;

        if (this.HREmp.EmpEmailId != null) {
          this.onboardingform.get("emailId").disable();
          this.onboardingform.get("Type").disable();
          this.onboardingform.get("GroupId").disable();
        }
      }
    });
    this.cdr.detectChanges();
  }

  getDeptData() {
    this.hrSvc.getEmployeebyId(this.EmpId).subscribe((data: any) => {
      this.HREmp = data;
      this.HREmp.mobileNumber = this.HREmp.mobileNumber.trim();
      this.departmentsList &&
        this.departmentsList.map((item) => {
          if (item.ID == this.HREmp.DepartmentId) {
            this.departmentId = item.DepartmentName;
          }
        });
      if (this.HREmp.EmpEmailId != null) {
        this.onboardingform.get("emailId").disable();
        this.onboardingform.get("Type").disable();
        this.onboardingform.get("GroupId").disable();
      }
    });
  }

  getCadreData() {
    this.hrSvc.getEmployeebyId(this.EmpId).subscribe((data: any) => {
      this.HREmp = data;
      this.HREmp.mobileNumber = this.HREmp.mobileNumber.trim();
      this.cadresList &&
        this.cadresList.map((item) => {
          if (item.ID == this.HREmp.CadreId) {
            this.cadreId = item.CadreName;
          }
        });
      if (this.HREmp.EmpEmailId != null) {
        this.onboardingform.get("emailId").disable();
      }
    });
  }

  getLocations() {
    this.hrSvc.getLocations().subscribe((data: any) => {
      this.locationsList = data;
    });
  }
  getDepartments() {
    this.deptSvc.getDepartments().subscribe((data: any) => {
      this.departmentsList = data;
    });
  }
  getCadres() {
    this.cadreSvc.getCadres().subscribe((data: any) => {
      this.cadresList = data;
    });
  }

  getEeTypeList() {
    this.deptSvc.getMasterGroupByCategory("EeType").subscribe((data: any) => {
      this.deptSvc
        .getMasterGroupByGroupID(data[0].ID)
        .subscribe((dataList: any) => {
          this.eeTypeList = dataList;
        });
    });
  }

  getTeams() {
    this.deptSvc.getMasterGroupByCategory("Team").subscribe((data: any) => {
      this.deptSvc
        .getMasterGroupByGroupID(data[0].ID)
        .subscribe((dataList: any) => {
          this.teamList = dataList;
          this.teamList = this.teamList.filter(
            (team) => team.Value != "Onshore"
          );
        });
    });
  }

  getAllEmplist() {
    this.employeelist = [];
    this.onboardsvc.getEmpList().subscribe(
      (data: OnboardingHRDetail[]) => {
        this.employeelist = data;
      },
      (error) => (this.error = error)
    );
  }

  getDetailsByGroupID(groupID: string): Promise<{ result: boolean; emp: any }> {
    return new Promise((resolve, reject) => {
      this.emp_Svc.getEmployeeDetailsByGroupId(groupID).subscribe(
        (data: any) => {
          this.EmpGroupIDDetails = data;
          const emp = this.EmpGroupIDDetails.IsMigratedOnH1
            ? new Date(this.EmpGroupIDDetails.US_DOE)
            : new Date(this.EmpGroupIDDetails.DateOfExit);
          emp.setHours(0, 0, 0, 0);
          const empDate = new Date(emp).getTime();
          const doj = new Date(this.HREmp.DOJ);
          doj.setHours(0, 0, 0, 0);
          const dojDate = doj.getTime();
          if (isNaN(empDate) || isNaN(dojDate)) {
            reject(false);
            return;
          }

          const result = empDate >= dojDate;

          // Resolve with the result and emp
          resolve({ result, emp });
        },
        (error) => {
          console.error("Error fetching employee details:", error);
          reject(false); // Reject the promise in case of error
        }
      );
    });
  }

  getEmployeeById() {
    if (this.EmpId != null) {
      this.onboardsvc.getEmployeebyId(this.EmpId).subscribe((data: any) => {
        this.gettingBasicDet = data;
        this.gettingBasicDet.EmpCode = this.EmpId;
      });
    }
  }

  getfileName() {
    if (
      this.HREmp != null &&
      this.gettingBasicDet != null &&
      this.HREmp.OfferLetterDocumentName != null
    ) {
      return this.gettingBasicDet.FirstName + "_Offer Letter";
    } else return null;
  }

  activate() {
    const tempObj = {
      empCode: this.LoginEmpCode,
      OTPCode: this._onboardOTP.OTPCode,
    };
    if (this._onboardOTP) {
      this._onboardingService.validateOTP(tempObj).subscribe(
        (data: any) => {
          this.error = "";
          if (data.Success == true) {
            this.exception = false;
            this.OtpText = false;
            this.isAllowAccess = true;
          } else {
            this.exception = true;
            this.error = data.ErrorMessage;
            this.toastr.warning("Invalid OTP");
          }
        },
        (error) => (this.error = error)
      );
    }
  }

  getBasicEmployeeByCodeforNumber() {
    if (this.empCode != null) {
      this.emp_Svc.getBasicEmployeeById(this.empCode).subscribe((data: any) => {
        this.MobileNo = data.MobileNo;
      });
    }
    this.cdr.detectChanges();
    return this.MobileNo;
  }

  generateOTP() {
    this.error = "Wait for few seconds....";
    //const slugValue = this.slugify(this.LoginEmpCode);
    this._onboardingService
      .generateOTP(this.LoginEmpCode, "hiringInfo")
      .subscribe(
        (data: any) => {
          this.error = "";
          if (data.Success == true) {
            this.exception = false;
            this.OtpText = true;
            const num = this.getBasicEmployeeByCodeforNumber();
            this.toastr.success(
              "OTP has been sent to mobile# XXXXXX" + num.slice(-4)
            );
          } else {
            this.exception = true;
            this.error = data.ErrorMessage;
            this.toastr.warning(this.error);
          }
        },
        (error) => (this.error = error)
      );
  }

  getCtcFileNames(item) {
    if (item != null && item.OfferLetterDocumentPath != null) {
      return (
        // this.gettingBasicDet.EmpCode +
        // "_" +
        this.HREmp.FirstName +
        (this.HREmp.LastName === null ? "_" : " " + this.HREmp.LastName) +
        "_Offer Letter"
      );
    } else return null;
  }

  handleFile(event, itemData, j = null) {
    if (event.target.files == undefined) {
      // this.HREmp.OfferLetterFile = null;
      this.HREmp.offerLetterDetails = [];
    }
    const files: FileList = event.target.files;
    if (files && files.length > 0) {
      if (!this.validFileType(files[0])) {
        this.toastr.warning(
          "File name " + files[0].name + ": Not a valid file type."
        );
        event.srcElement.value = null;
        event.currentTarget.value = null;
      }
      //  Don't allow file sizes over 1MB
      if (files[0].size < this.MAX_SIZE) {
        const fileDataObj = {
          EffectiveDate: itemData.EffectiveDate,
          EmpCode: this.HREmp.EmpCode,
          JoiningBonus: itemData.JoiningBonus,
          RelocationEligibility: this.HREmp.RelocationEligibility,
          OfferLetterDocumentName: this.HREmp.OfferLetterDocumentName,
          OfferLetterFile: this.file_Svc.readAndUploadFile(files),
        };
        this.arrFilesList.push(fileDataObj);
        this.HREmp.offerLetterDetails = this.arrFilesList;
        this.HREmp.OfferLetterDocumentPath = null;
        this.isUpdated = j;
      } else {
        this.toastr.warning(
          " File: " +
          files[0].name +
          " exceeds 1MB hence it cannot be uploaded."
        );
        event.srcElement.value = null;
        event.currentTarget.value = null;
      }
    }
  }

  validFileType(file) {
    let types = [...File_Types, ...Resume_File_Types];
    return types.includes(file.type);
  }

  ngDoCheck() {
    // if (this.HREmp.OfferLetterDocumentPath) {
    //   this.onboardingform.controls["OfferLetterFile"].clearValidators();
    //   this.onboardingform.controls["OfferLetterFile"].setErrors(null);
    // }
  }

  encryptFun(data) {
    try {
      data = data === undefined ? "" : data;
      data = data.toString();

      let cipherPhrase = this.privateKeyBase64;

      var key = CryptoJS.enc.Utf8.parse(cipherPhrase);
      var iv = CryptoJS.enc.Utf8.parse(""); // Empty IV as per your decryption code.

      var encrypted = CryptoJS.AES.encrypt(data, key, {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });

      return encrypted.toString(); // Return as a base64 string
    } catch (e) {
      console.log(e);
    }
  }

  splitCamelCase(value: string): string {
    return value.replace(/(?<!^)([A-Z])/g, " $1");
  }

  async addDetails() {
    this.isLoader = true;
    try {
      const data: BasicEmployeeDetails[] = await this.emp_Svc
        .getAllEmployees()
        .toPromise();
      this.BasicEmployeeList = data || [];
      this.isLoader = false;

      this.onboardingform.markAllAsTouched();
      const controls = this.onboardingform.controls;
      // if (this.HREmp.employeeBonusDetailsList) {
      //   const stringifiedData = JSON.stringify(
      //     this.HREmp.employeeBonusDetailsList
      //   );
      //   this.HREmp.employeeBonusDetailsList = this.encryptFun(stringifiedData);
      // }
      for (const controlName in controls) {
        if (controls[controlName].invalid) {
        }
      }
      if (this.onboardingform.invalid) {
        this.toastr.warning("Please fill in the required fields");
        return;
      }
      if (this.HREmp.Type == "Re-hire") {
        const duplicateGrpId = this.employeelist
          .filter(
            (emp) =>
              emp.GroupId == this.HREmp.GroupId &&
              emp.EmpId != this.HREmp.EmpId &&
              (emp.IsDeleted == false && emp.Status != 3)
          )
          .pop();
        if (duplicateGrpId != undefined) {
          this.toastr.warning(
            "Same Group Id exists for onboarding employee " +
            duplicateGrpId.EmpEmailId
          );
          return;
        } else {
          const details =
            this.BasicEmployeeList.length > 0
              ? this.BasicEmployeeList.filter((emp) => {
                return (
                  emp.GroupId === this.HREmp.GroupId &&
                  (emp.SecondaryEmail === this.HREmp.EmpEmailId ||
                    emp.ActualFirstName === this.HREmp.FirstName ||
                    emp.LastName === this.HREmp.LastName ||
                    emp.MobileNo.trim() === this.HREmp.mobileNumber.trim())
                );
              }).pop()
              : null;
          if (details != undefined) {
            const isH1Migrated = details.IsMigratedOnH1;
            const isValidDateOfExit = isH1Migrated
              ? details.US_DOE != null
              : details.DateOfExit != null;
            if (isValidDateOfExit) {
              this.getDetailsByGroupID(this.HREmp.GroupId).then((data) => {
                if (data.result) {
                  this.toastr.warning(
                    "DOJ should be after the earlier Date of exit " +
                    formatDate(new Date(data.emp), "dd-MMM-yyyy", "en_US")
                  );
                  return;
                } else {
                  if (this.onboardingform.controls.emailId.disabled == false) {
                    this.emailemp = this.employeelist.filter(
                      (emp) =>
                        (emp.Status != 3 && emp.IsDeleted != 1) &&
                        this.HREmp.EmpEmailId.toLowerCase() ==
                        emp.EmpEmailId.toLowerCase() &&
                        this.HREmp.mobileNumber == emp.mobileNumber
                    );
                    var empActive = this.empList.filter(
                      (emp) =>
                        emp.SecondaryEmail != null &&
                        this.HREmp.EmpEmailId.toLowerCase() ==
                        emp.SecondaryEmail.toLowerCase() &&
                        this.HREmp.mobileNumber == emp.MobileNo &&
                        (emp.IsMigratedOnH1
                          ? emp.US_DOE == null
                          : emp.DateOfExit == null)
                    );
                    //  this.mobileemp = this.employeelist.filter(emp => this.HREmp.mobileNumber == emp.mobileNumber)
                    if (this.emailemp.length > 0 || empActive.length > 0) {
                      this.toastr.warning(
                        "Same Email and Mobile number exists"
                      );
                    } else {
                      this.submitted = true;

                      this.datePipe = new DatePipe("en-US");
                      this.HREmp.DOJ = new Date(
                        this.datePipe.transform(
                          this.HREmp.DOJ,
                          this.config.dateFormat()
                        )
                      );
                      this.HREmp.CreatedBy = this.empCode;
                      this.HREmp.EmpType = "FTE";
                      this.HREmp.CurrentURL = this.config.winPayURL;
                      this.HREmp.mobileNumber = this.HREmp.mobileNumber.trim();
                      this.disablesubmit = true;
                      this.HREmp.employeeBonusDetails = this.bonusDetails.value;
                      if (
                        this.HREmp.employeeBonusDetails != null &&
                        this.HREmp.employeeBonusDetails.length > 0
                      ) {
                        for (
                          var i = 0;
                          i < this.HREmp.employeeBonusDetails.length;
                          i++
                        ) {
                          this.HREmp.employeeBonusDetails[i].EmpId =
                            this.HREmp.employeeBonusDetails[i].EmpId > 0
                              ? this.HREmp.employeeBonusDetails[i].EmpId
                              : this.HREmp.EmpId;
                        }
                      }
                      this.cdr.detectChanges();

                      if (this.HREmp.employeeBonusDetailsList.length > 0) {
                        for (
                          var i = 0;
                          i < this.HREmp.employeeBonusDetailsList.length;
                          i++
                        ) {
                          if (
                            this.HREmp.employeeBonusDetailsList[i].EffectiveDate
                              ._d
                          ) {
                            const effectiveDate = moment(
                              this.HREmp.employeeBonusDetailsList[i]
                                .EffectiveDate._d
                            );
                            const formattedDate = effectiveDate.format(
                              "YYYY-MM-DD hh:mm:ss.SSS"
                            );
                            this.HREmp.employeeBonusDetailsList[
                              i
                            ].EffectiveDate = formattedDate;
                          }
                        }
                        const finalData = this.HREmp.employeeBonusDetailsList;

                        this.HREmp.orgEmployeeBonusDetailsList = [...finalData];
                        const encryptedData = finalData.map((obj) => {
                          Object.entries(obj).forEach(([key, value]) => {
                            obj[key] =
                              key === "RelocationEligibility"
                                ? value
                                : key === "EffectiveDate"
                                  ? value
                                  : key === "EmpCode"
                                    ? value
                                    : key === "OfferLetterDocumentName"
                                      ? value
                                      : key === "OfferLetterDocumentPath"
                                        ? value
                                        : key === "JoiningBonus"
                                          ? value
                                          : value
                                            ? this.encryptFun(value)
                                            : value;
                          });
                          return obj;
                        });
                        const finalDataRes = encryptedData.map(
                          ({ orgEmployeeBonusDetailsList, ...rest }) => rest
                        );
                        this.HREmp.employeeBonusDetailsList = finalDataRes;
                      }

                      this.hrSvc.addEmployee(this.HREmp).subscribe(
                        (data: any) => {
                          // const decryptedData =
                          //   this.HREmp.employeeBonusDetailsList.map((obj) => {
                          //     Object.entries(obj).forEach(([key, value]) => {
                          //       obj[key] =
                          //         key === "RelocationEligibility"
                          //           ? value
                          //           : key === "EffectiveDate"
                          //           ? value
                          //           : key === "EmpCode"
                          //           ? value
                          //           : this.decryptAES(
                          //               value,
                          //               this.privateKeyBase64
                          //             );
                          //     });
                          //     return obj;
                          //   });

                          // this.HREmp.employeeBonusDetailsList = decryptedData;

                          this.error = "";
                          if (data.Success == true) {
                            this.toastr.success(
                              "Employee is initiated successfully"
                            );
                            this.disablesubmit = false;
                            this.cdr.detectChanges();
                            this.router.navigateByUrl("/employeelist");
                          } else {
                            this.exception = true;
                            this.error = data.ErrorMessage;
                          }
                        },
                        (error) => (
                          (this.disablesubmit = false),
                          (this.error = error),
                          this.cdr.detectChanges()
                        )
                      );
                    }
                  } else {
                    this.submitted = true;

                    this.datePipe = new DatePipe("en-US");
                    this.HREmp.DOJ = new Date(
                      this.datePipe.transform(
                        this.HREmp.DOJ,
                        this.config.dateFormat()
                      )
                    );
                    this.HREmp.CreatedBy = this.empCode;
                    this.HREmp.EmpType = "FTE";
                    this.HREmp.CurrentURL = this.config.winPayURL;
                    this.HREmp.mobileNumber = this.HREmp.mobileNumber.trim();
                    this.HREmp.employeeBonusDetails = this.bonusDetails.value;
                    if (
                      this.HREmp.employeeBonusDetails != null &&
                      this.HREmp.employeeBonusDetails.length > 0
                    ) {
                      for (
                        var i = 0;
                        i < this.HREmp.employeeBonusDetails.length;
                        i++
                      ) {
                        this.HREmp.employeeBonusDetails[i].EmpId =
                          this.HREmp.employeeBonusDetails[i].EmpId > 0
                            ? this.HREmp.employeeBonusDetails[i].EmpId
                            : this.HREmp.EmpId;
                      }
                    }

                    if (this.HREmp.employeeBonusDetailsList.length > 0) {
                      for (
                        var i = 0;
                        i < this.HREmp.employeeBonusDetailsList.length;
                        i++
                      ) {
                        if (
                          this.HREmp.employeeBonusDetailsList[i].EffectiveDate
                            ._d
                        ) {
                          const effectiveDate = moment(
                            this.HREmp.employeeBonusDetailsList[i].EffectiveDate
                              ._d
                          );
                          const formattedDate = effectiveDate.format(
                            "YYYY-MM-DD hh:mm:ss.SSS"
                          );
                          this.HREmp.employeeBonusDetailsList[i].EffectiveDate =
                            formattedDate;
                        }
                      }
                      const finalData = this.HREmp.employeeBonusDetailsList;

                      this.HREmp.orgEmployeeBonusDetailsList = [...finalData];
                      const encryptedData = finalData.map((obj) => {
                        Object.entries(obj).forEach(([key, value]) => {
                          obj[key] =
                            key === "RelocationEligibility"
                              ? value
                              : key === "EffectiveDate"
                                ? value
                                : key === "EmpCode"
                                  ? value
                                  : key === "OfferLetterDocumentName"
                                    ? value
                                    : key === "OfferLetterDocumentPath"
                                      ? value
                                      : key === "JoiningBonus"
                                        ? value
                                        : value
                                          ? this.encryptFun(value)
                                          : value;
                        });
                        return obj;
                      });
                      const finalDataRes = encryptedData.map(
                        ({ orgEmployeeBonusDetailsList, ...rest }) => rest
                      );
                      this.HREmp.employeeBonusDetailsList = finalDataRes;
                    }

                    this.hrSvc.addEmployee(this.HREmp).subscribe(
                      (data: any) => {
                        // const decryptedData =
                        //   this.HREmp.employeeBonusDetailsList.map((obj) => {
                        //     Object.entries(obj).forEach(([key, value]) => {
                        //       obj[key] =
                        //         key === "RelocationEligibility"
                        //           ? value
                        //           : key === "EffectiveDate"
                        //           ? value
                        //           : key === "EmpCode"
                        //           ? value
                        //           : this.decryptAES(
                        //               value,
                        //               this.privateKeyBase64
                        //             );
                        //     });
                        //     return obj;
                        //   });

                        // this.HREmp.employeeBonusDetailsList = decryptedData;
                        this.error = "";
                        if (data.Success == true) {
                          this.toastr.success(
                            "Employee is initiated successfully"
                          );
                          this.router.navigateByUrl("/employeelist");
                        } else {
                          this.exception = true;
                          this.error = data.ErrorMessage;
                        }
                      },
                      (error) => (this.error = error)
                    );
                  }
                }
              });
            } else {
              alert("Date of exit is Blank for the earlier record/s");
            }
          } else if (details == undefined) {
            alert(
              "First Name/Last Name/email/Mobile Number entered is not matching with the details under GroupID " +
              this.HREmp.GroupId
            );
          }
        }
      } else if (this.HREmp.Type == "New") {
        if (this.onboardingform.controls.emailId.disabled == false) {
          this.emailemp = this.employeelist.filter(
            (emp) =>
              (emp.Status != 3 &&
                emp.IsDeleted != 1) &&
              this.HREmp.EmpEmailId.toLowerCase() ==
              emp.EmpEmailId.toLowerCase() &&
              this.HREmp.mobileNumber == emp.mobileNumber
          );
          var empActive = this.empList.filter(
            (emp) =>
              emp.SecondaryEmail != null &&
              this.HREmp.EmpEmailId.toLowerCase() ==
              emp.SecondaryEmail.toLowerCase() &&
              this.HREmp.mobileNumber == emp.MobileNo &&
              (emp.IsMigratedOnH1 ? emp.US_DOE == null : emp.DateOfExit == null)
          );
          //  this.mobileemp = this.employeelist.filter(emp => this.HREmp.mobileNumber == emp.mobileNumber)
          if (this.emailemp.length > 0 || empActive.length > 0) {
            this.toastr.warning("Same Email and Mobile number exists");
          } else {
            this.submitted = true;

            this.datePipe = new DatePipe("en-US");
            this.HREmp.DOJ = new Date(
              this.datePipe.transform(this.HREmp.DOJ, this.config.dateFormat())
            );
            this.HREmp.CreatedBy = this.empCode;
            this.HREmp.EmpType = "FTE";
            this.HREmp.CurrentURL = this.config.winPayURL;
            this.HREmp.mobileNumber = this.HREmp.mobileNumber.trim();
            this.disablesubmit = true;
            this.cdr.detectChanges();
            this.HREmp.employeeBonusDetails = this.bonusDetails.value;
            if (
              this.HREmp.employeeBonusDetails != null &&
              this.HREmp.employeeBonusDetails.length > 0
            ) {
              for (var i = 0; i < this.HREmp.employeeBonusDetails.length; i++) {
                this.HREmp.employeeBonusDetails[i].EmpId =
                  this.HREmp.employeeBonusDetails[i].EmpId > 0
                    ? this.HREmp.employeeBonusDetails[i].EmpId
                    : this.HREmp.EmpId;
              }
            }

            if (this.HREmp.employeeBonusDetailsList.length > 0) {
              for (
                var i = 0;
                i < this.HREmp.employeeBonusDetailsList.length;
                i++
              ) {
                if (this.HREmp.employeeBonusDetailsList[i].EffectiveDate._d) {
                  const effectiveDate = moment(
                    this.HREmp.employeeBonusDetailsList[i].EffectiveDate._d
                  );
                  const formattedDate = effectiveDate.format(
                    "YYYY-MM-DD hh:mm:ss.SSS"
                  );
                  this.HREmp.employeeBonusDetailsList[i].EffectiveDate =
                    formattedDate;
                }
              }
              const finalData = this.HREmp.employeeBonusDetailsList;

              this.HREmp.orgEmployeeBonusDetailsList = [...finalData];
              const encryptedData = finalData.map((obj) => {
                Object.entries(obj).forEach(([key, value]) => {
                  obj[key] =
                    key === "RelocationEligibility"
                      ? value
                      : key === "EffectiveDate"
                        ? value
                        : key === "EmpCode"
                          ? value
                          : key === "OfferLetterDocumentName"
                            ? value
                            : key === "OfferLetterDocumentPath"
                              ? value
                              : key === "JoiningBonus"
                                ? value
                                : value
                                  ? this.encryptFun(value)
                                  : value;
                });
                return obj;
              });
              const finalDataRes = encryptedData.map(
                ({ orgEmployeeBonusDetailsList, ...rest }) => rest
              );
              this.HREmp.employeeBonusDetailsList = finalDataRes;
            }

            this.hrSvc.addEmployee(this.HREmp).subscribe(
              (data: any) => {
                // const decryptedData = this.HREmp.employeeBonusDetailsList.map(
                //   (obj) => {
                //     Object.entries(obj).forEach(([key, value]) => {
                //       obj[key] =
                //         key === "RelocationEligibility"
                //           ? value
                //           : key === "EffectiveDate"
                //           ? value
                //           : key === "EmpCode"
                //           ? value
                //           : this.decryptAES(value, this.privateKeyBase64);
                //     });
                //     return obj;
                //   }
                // );

                // this.HREmp.employeeBonusDetailsList = decryptedData;
                this.error = "";
                if (data.Success == true) {
                  this.toastr.success("Employee is initiated successfully");
                  this.disablesubmit = false;
                  this.cdr.detectChanges();
                  this.router.navigateByUrl("/employeelist");
                } else {
                  this.exception = true;
                  this.error = data.ErrorMessage;
                }
              },
              (error) => (
                (this.disablesubmit = false),
                (this.error = error),
                this.cdr.detectChanges()
              )
            );
          }
        } else {
          this.submitted = true;

          this.datePipe = new DatePipe("en-US");
          this.HREmp.DOJ = new Date(
            this.datePipe.transform(this.HREmp.DOJ, this.config.dateFormat())
          );
          this.HREmp.CreatedBy = this.empCode;
          this.HREmp.EmpType = "FTE";
          this.HREmp.CurrentURL = this.config.winPayURL;
          this.HREmp.mobileNumber = this.HREmp.mobileNumber.trim();
          this.HREmp.employeeBonusDetails = this.bonusDetails.value;
          if (
            this.HREmp.employeeBonusDetails != null &&
            this.HREmp.employeeBonusDetails.length > 0
          ) {
            for (var i = 0; i < this.HREmp.employeeBonusDetails.length; i++) {
              this.HREmp.employeeBonusDetails[i].EmpId =
                this.HREmp.employeeBonusDetails[i].EmpId > 0
                  ? this.HREmp.employeeBonusDetails[i].EmpId
                  : this.HREmp.EmpId;
            }
          }
          if (this.HREmp.employeeBonusDetailsList.length > 0) {
            for (
              var i = 0;
              i < this.HREmp.employeeBonusDetailsList.length;
              i++
            ) {
              if (this.HREmp.employeeBonusDetailsList[i].EffectiveDate._d) {
                const effectiveDate = moment(
                  this.HREmp.employeeBonusDetailsList[i].EffectiveDate._d
                );
                const formattedDate = effectiveDate.format(
                  "YYYY-MM-DD hh:mm:ss.SSS"
                );
                this.HREmp.employeeBonusDetailsList[i].EffectiveDate =
                  formattedDate;
              }
            }
            const finalData = this.HREmp.employeeBonusDetailsList;

            this.HREmp.orgEmployeeBonusDetailsList = [...finalData];
            const encryptedData = finalData.map((obj) => {
              Object.entries(obj).forEach(([key, value]) => {
                obj[key] =
                  key === "RelocationEligibility"
                    ? value
                    : key === "EffectiveDate"
                      ? value
                      : key === "EmpCode"
                        ? value
                        : key === "OfferLetterDocumentName"
                          ? value
                          : key === "OfferLetterDocumentPath"
                            ? value
                            : key === "JoiningBonus"
                              ? value
                              : value
                                ? this.encryptFun(value)
                                : value;
              });
              return obj;
            });
            const finalDataRes = encryptedData.map(
              ({ orgEmployeeBonusDetailsList, ...rest }) => rest
            );
            this.HREmp.employeeBonusDetailsList = finalDataRes;
          }

          this.hrSvc.addEmployee(this.HREmp).subscribe(
            (data: any) => {
              // const decryptedData = this.HREmp.employeeBonusDetailsList.map(
              //   (obj) => {
              //     Object.entries(obj).forEach(([key, value]) => {
              //       obj[key] =
              //         key === "RelocationEligibility"
              //           ? value
              //           : key === "EffectiveDate"
              //           ? value
              //           : key === "EmpCode"
              //           ? value
              //           : this.decryptAES(value, this.privateKeyBase64);
              //     });
              //     return obj;
              //   }
              // );

              // this.HREmp.employeeBonusDetailsList = decryptedData;
              this.error = "";
              if (data.Success == true) {
                this.toastr.success("Employee is initiated successfully");
                this.router.navigateByUrl("/employeelist");
              } else {
                this.exception = true;
                this.error = data.ErrorMessage;
              }
            },
            (error) => (this.error = error)
          );
        }
      }
    } catch (error) {
      this.error = error;
      this.isLoader = false;
      throw error; // Rethrow or handle the error appropriately
    }
  }

  getBonusList() {
    this.emp_Svc.getEmpBonus().subscribe(
      (data: any) => {
        this.bonusOptions = data || [];
        // this.cdr.detectChanges();
      },
      (error) => {
        this.error = error;
      }
    );
  }

  onSelectionChange(index: number, selectedValue: string) {
    this.selectedBonusOptions[index] = selectedValue;
  }

  getFilteredBonusOptions(index: number) {
    return this.bonusOptions.filter(
      (option) =>
        !this.selectedBonusOptions.includes(option.Name) ||
        this.selectedBonusOptions[index] === option.Name
    );
  }

  async Reset() {
    await this.getEmployeeList();
    this.onboardingform.reset();
    this.getData();
    this.getDesignations();
    this.getCadreData();
    this.getDepartments();
    this.getDeptData();
    this.getCadres();
    this.getTeams();
    this.getEeTypeList();
    this.getJobSources();
    this.getDesignations();
    this.getAllEmplist();
  }

  addJobSource() {
    const message = `Add New JobSource`;
    const dialogData = new ProfilesourceDialog(
      "jobSource",
      "Action",
      message,
      null
    );
    const dialogRef = this.dialog.open(ProfilesourceDialogComponent, {
      width: "400px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.getJobSources();
          this.HREmp.ProfileSource = dialogResult.Name;
          this.selectedProfileSource = dialogResult.Name;
          this.showOtherControl = true;
          setTimeout(() => {
            const selectedId = this.jobsources.find(
              ({ Name }) => Name === this.HREmp.ProfileSource
            ).Id;
            this.getJobPlatform(selectedId);
          }, 500);
        }
      },
      (error) => {
        this.error = error;
      }
    );
    this.cdr.detectChanges();
  }

  addJobPlatform() {
    const message = `Add New Sub-Category`;
    const dialogData = new ProfilesourceDialog(
      "jobPlatform",
      "Action",
      message,
      this.selectedProfileSource
    );
    const dialogRef = this.dialog.open(ProfilesourceDialogComponent, {
      width: "400px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          // this.HREmp.ProfileSource = dialogResult.Name;
          this.getJobSources();
          this.HREmp.ProfileSourceCategoryOne = dialogResult.Name;
          this.Required = false;
          setTimeout(() => {
            const selectedId = this.jobsources.find(
              ({ Name }) => Name === this.HREmp.ProfileSource
            ).Id;
            this.getJobPlatform(selectedId);
          }, 1000);
          this.cdr.detectChanges();
        }
      },
      (error) => {
        this.error = error;
      }
    );
  }

  onSelectionChangeProfileSource(event) {
    this.selectedProfileSource = event.value || event!.option!.id;
    this.oldJobSource =
      this.oldJobSource == null ? event.value : this.oldJobSource;
    const selectedId = this.jobsources.find(
      ({ Name }) => Name === this.selectedProfileSource
    ).Id;
    if (event.value != null && event.value != this.oldJobSource) {
      this.HREmp.ProfileSourceCategoryOne = null;
      this.HREmp.ProfileSourceCategoryTwo = null;
    }
    if (
      this.selectedProfileSource != null &&
      this.HREmp.ProfileSource != "Career Portal"
    ) {
      this.getJobPlatform(selectedId);
      this.HREmp.ProfileSourceCategoryTwo = null;
    }
    if (
      this.selectedProfileSource != null &&
      this.HREmp.ProfileSource == "Career Portal"
    ) {
      this.HREmp.ProfileSourceCategoryOne = "None";
    }
    if (
      this.selectedProfileSource != null &&
      this.HREmp.ProfileSource == "Direct re-hire"
    ) {
      this.HREmp.ProfileSourceCategoryOne = "None";
    }
    this.oldJobSource = event.value;

    var others = this.onboardingform.get("ProfileSourceCategoryTwo");
    if (
      this.HREmp.ProfileSource != null &&
      this.HREmp.ProfileSource != "" &&
      this.HREmp.ProfileSource != "Social Network" &&
      this.HREmp.ProfileSource != "Career Portal" &&
      this.HREmp.ProfileSource != "Job Board" &&
      this.HREmp.ProfileSource != "Direct re-hire"
    ) {
      others.setValue(null);
      this.HREmp.ProfileSourceCategoryTwo = null;
      others.clearValidators();
      this.showOtherControl = true;
    } else if (
      this.HREmp.ProfileSource != null &&
      this.HREmp.ProfileSource != ""
    ) {
      this.showOtherControl = false;
    }
    if (
      (!isNullOrUndefined(this.selectedProfileSource) &&
        this.HREmp.ProfileSource == "Vendor") ||
      this.HREmp.ProfileSource == "Referral" ||
      this.HREmp.ProfileSource == "RPO"
    ) {
      others.setValidators([Validators.required]);
    } else {
      others.clearValidators();
      others.updateValueAndValidity();
    }
    this.cdr.detectChanges();
  }

  ChangeDesignation() {
    const message = `Add New Designation`;

    const dialogData = new DesignationDialog("Action", message);
    const dialogRef = this.dialog.open(DesignationDialogComponent, {
      width: "400px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.getDesignations();
          this.designationId = dialogResult.DesignationName;
          this.Required = false;
        }
      },
      (error) => {
        this.error = error;
      }
    );
  }

  doFilter() {
    if (!isNullOrUndefined(this.designationId)) {
      this.filteredList = this.filter(this.designationsList);
    }
  }

  async getAllEmployees() {
    this.isLoader = true;
    try {
      const data: BasicEmployeeDetails[] = await this.emp_Svc
        .getAllEmployees()
        .toPromise();
      this.BasicEmployeeList = data || [];
      this.isLoader = false;
    } catch (error) {
      this.error = error;
      this.isLoader = false;
      throw error; // Rethrow or handle the error appropriately
    }
  }

  setType() {
    if (this.HREmp.Type == "Re-hire") {
      this.HREmp.GroupId = "WW";
    } else {
      this.HREmp.GroupId = null;
    }
  }

  onKeyPress(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    if (!value.startsWith("WW")) {
      input.value = "WW";
      this.HREmp.GroupId = input.value;
      return;
    }
    if (value.length < 2) {
      if (event.key !== "W") {
        event.preventDefault();
      }
    }
    if (value.length > 2) {
      const numericPart = value.slice(2);
      const filteredNumericPart = numericPart.replace(/\D/g, "");
      input.value = "WW" + filteredNumericPart.slice(0, 6);
    }
    if (value.length >= 8) {
      event.preventDefault();
    }
  }

  onSelectionChanged(event) {
    if (event.option.value == "") {
      this.ChangeDesignation();
    } else {
      this.HREmp.DesignationId = event.option.id;
    }
  }

  onEmpSelectionChanged(event) {
    this.HREmp.RecruiterId = event.option.id;
    this.HREmp.RecruiterDesignationId =
      this.empList.filter((emp) => this.HREmp.RecruiterId == emp.EmpCode)
        .length > 0
        ? this.empList.filter((emp) => this.HREmp.RecruiterId == emp.EmpCode)[0]
          .DesignationId
        : null;
    this.RecruiterDesignation =
      this.designationsList.filter(
        (desg) => desg.ID == this.HREmp.RecruiterDesignationId
      ).length > 0
        ? this.designationsList.filter(
          (desg) => desg.ID == this.HREmp.RecruiterDesignationId
        )[0].DesignationName
        : null;
    this.onboardingform
      .get("RecruiterDesignationId")
      .setValue(this.RecruiterDesignation);
  }

  getEmployeeList(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.emp_Svc.getAllActiveEmployees().subscribe(
        (data: any[]) => {
          const tempList = [];
          this.empList = data;
          this.empList.forEach((el) => {
            let item = el;
            item.recDisplayName = el.FirstName + " - " + el.EmpCode;
            item.recEmpCode = el.EmpCode;
            tempList.push(item);
          });
          this.empList = tempList;
          this.filteredEmpList = this.empList;

          resolve(this.empList);
        },
        (error) => reject(error)
      );
    });
  }

  filterRecList(values, recr) {
    return values.filter((value) =>
      value.recDisplayName.toLowerCase().includes(recr.toLowerCase())
    );
  }

  doEmpFilter(searchTerm) {
    if (!searchTerm) {
      this.filteredEmpList = this.empList;
    } else {
      if (!isNullOrUndefined(searchTerm)) {
        this.filteredEmpList = this.filterRecList(this.empList, searchTerm);
      }

      // if (!isNullOrUndefined(this.RecruiterId)) {
      //   this.filteredEmpList = this.empList.filter(
      //     (emp) =>
      //       emp.FirstName.toLowerCase().includes(searchTerm) ||
      //       emp.EmpCode.toString().toLowerCase().includes(searchTerm)
      //   );
      // }
    }
  }

  filter(values) {
    return values.filter((value) =>
      value.DesignationName.toLowerCase().includes(
        this.designationId.toLowerCase()
      )
    );
  }

  Cancel() {
    this.router.navigateByUrl("/employeelist");
  }

  addCompensation(val) {
    const dialogData = new BonusDialog("Action", val);
    const dialogRef = this.dialog.open(CompensationDialogComponent, {
      width: "400px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.getBonusList();
          setTimeout(() => {
            // const bonusDetailGroup = this.bonusDetails.at(i);
            const res = this.bonusOptions.filter((b) => {
              return b.Name === dialogResult.Name;
            });
            if (res.length === 1) {
              this.addNewCtcCmp();
            } else {
            }
          }, 500);
        }
      },
      (error) => {
        this.error = error;
      }
    );
  }

  //Custom validation for Designation(Mat autocomplete) to validate user text with designations list
  //Returns true if user text is not found in designation list
  private requireMatch(control: FormControl): ValidationErrors | null {
    const selection: any = control.value;
    let match = null;
    if (!isNullOrUndefined(selection) && selection != "") {
      if (this.Required == true) {
        if (!isNullOrUndefined(this.designationsList)) {
          for (var i = 0; i < this.designationsList.length; i++) {
            if (this.designationsList[i].DesignationName == selection) {
              match = null;
              break;
            } else {
              match = true;
            }
          }
          if (match == true) {
            return { requireMatch: match };
          }
        }
      }
    } else {
      return null;
    }
  }

  private requireMatchDept(control: FormControl): ValidationErrors | null {
    const selectionDept: any = control.value;
    let match = null;
    if (!isNullOrUndefined(selectionDept) && selectionDept != "") {
      if (this.RequiredDept == true) {
        if (!isNullOrUndefined(this.departmentsList)) {
          for (var i = 0; i < this.departmentsList.length; i++) {
            if (this.departmentsList[i].DepartmentName == selectionDept) {
              match = null;
              break;
            } else {
              match = true;
            }
          }
          if (match == true) {
            return { requireMatchDept: match };
          }
        }
      }
    } else {
      return null;
    }
  }
  private requireMatchProfileSource(
    control: FormControl
  ): ValidationErrors | null {
    const selectionProfileSource: any = control.value;
    let match = null;
    if (
      !isNullOrUndefined(selectionProfileSource) &&
      selectionProfileSource != ""
    ) {
      if (this.RequiredCadre == true) {
        if (!isNullOrUndefined(this.jobsources)) {
          for (var i = 0; i < this.jobsources.length; i++) {
            if (this.jobsources[i].Name == selectionProfileSource) {
              match = null;
              break;
            } else {
              match = true;
            }
          }
          if (match == true) {
            return { requireMatchProfileSource: match };
          }
        }
      }
    } else {
      return null;
    }
  }

  private requireMatchRecruiterId(
    control: FormControl
  ): ValidationErrors | null {
    const selectionRecruiterId: any = control.value;
    let match = null;
    if (
      !isNullOrUndefined(selectionRecruiterId) &&
      selectionRecruiterId != ""
    ) {
      if (!isNullOrUndefined(this.filteredEmpList)) {
        for (var i = 0; i < this.filteredEmpList.length; i++) {
          if (this.filteredEmpList[i].recDisplayName == selectionRecruiterId) {
            match = null;
            break;
          } else {
            match = true;
          }
        }
        if (match == true) {
          return { requireMatchRecruiterId: match };
        }
      }
    } else {
      return null;
    }
  }

  private requireMatchCadre(control: FormControl): ValidationErrors | null {
    const selectionCadre: any = control.value;
    let match = null;
    if (!isNullOrUndefined(selectionCadre) && selectionCadre != "") {
      if (this.RequiredCadre == true) {
        if (!isNullOrUndefined(this.cadresList)) {
          for (var i = 0; i < this.cadresList.length; i++) {
            if (this.cadresList[i].CadreName == selectionCadre) {
              match = null;
              break;
            } else {
              match = true;
            }
          }
          if (match == true) {
            return { requireMatchCadre: match };
          }
        }
      }
    } else {
      return null;
    }
  }

  fetchURl(url) {
    this.emp_Svc
      .getDownloadURL(url)
      .subscribe((data: any) => {
        window.open(data, '_blank');
      });
  }
}
